import { useCallback, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

export const useAuthentication = () => {
  const storedUserData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const initialToken = storedUserData?.data?.token || "";

  const [isAuthenticated, setIsAuthenticated] = useState(!!initialToken);
  const [token, setToken] = useState(initialToken);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [phone, setPhone] = useState(null);

  const removeToken = useCallback(() => {
    localStorage.removeItem("logindata");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    setIsAuthenticated(false);
    setToken(null);
    setUserId(null);
    setRole(null);
    setPhone(null);
  }, []);

  const checkAuth = useCallback(() => {
    const data = JSON.parse(localStorage.getItem("logindata") || "{}");
    const storedToken = data?.data?.token || "";

    if (!storedToken) {
      removeToken();
      return;
    }

    setIsAuthenticated(true);
    setToken(storedToken);

    try {
      const decoded = jwtDecode(storedToken);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp && decoded.exp < currentTime) {
        removeToken();
        return;
      }
      setUserId(decoded.userId || null);
      setRole(decoded.role || null);
      // phone viene del JWT (login normal y Google login ya lo incluyen)
      // Si no está en el JWT, fallback a logindata.data.phone
      setPhone(decoded.phone || data?.data?.phone || null);
    } catch (error) {
      console.error("Error decoding token:", error);
      removeToken();
    }
  }, [removeToken]);

  useEffect(() => {
    checkAuth();
    window.addEventListener("storage", checkAuth);
    window.addEventListener("authChange", checkAuth);
    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("authChange", checkAuth);
    };
  }, [checkAuth]);

  return { isAuthenticated, token, userId, role, phone, removeToken };
};
